export const GA_CPL_BID_FIXED_DECIMALS = 3;
export const GA_CPL_BID_MULTIPLIER = 1000;
